import Api from '../api';

import { storeAction, clearAction } from './actions';

export default class AuthApi {
  static authLocal(email, password) {
    return Api.post('auth/local/Organizer', { email, password }).map((response) =>
      storeAction(response.token)
    );
  }

  static logoutLocal() {
    return Api.get('auth/local/logout').map(() => clearAction());
  }
}
